import { DateTime } from 'luxon';

import { Lane } from '..';

export class LaneQuoteData {
  lane?: Lane;
  effectiveDate?: DateTime;
  expirationDate?: DateTime;

  constructor(opts?: Partial<LaneQuoteData>) {
    if (opts?.lane != null) {
      this.lane = opts.lane;
    }
    if (opts?.effectiveDate != null) {
      this.effectiveDate = opts.effectiveDate;
    }
    if (opts?.expirationDate != null) {
      this.expirationDate = opts.expirationDate;
    }
  }
}
